﻿import { ApiResourceFactory } from '../api.resource.factory'
import { GroupModel, ResponseListModel, GroupRequestModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface IGroupsService {
    getLocationGroups(request: GroupRequestModel, state?: any): ng.IPromise<ResponseListModel<GroupModel>>
    getAlarmGroups(request: GroupRequestModel, state?: any): ng.IPromise<ResponseListModel<GroupModel>>
    getLocationAssignedGroups(request: GroupRequestModel, state?: any): ng.IPromise<ResponseListModel<GroupModel>>
}

export class GroupsService implements IGroupsService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getLocationGroups(request: GroupRequestModel, state: any = {}): ng.IPromise<ResponseListModel<GroupModel>> {
        var getLocationGroups: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<GroupModel>>> = this.apiResource.groups['getLocationGroups']
        if (state.request == undefined) {
            state.request = getLocationGroups(request)
        }
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getAlarmGroups(request: GroupRequestModel, state: any = {}): ng.IPromise<ResponseListModel<GroupModel>> {
        var getAlarmGroups: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<GroupModel>>> = this.apiResource.groups['getAlarmGroups']
        state.request = getAlarmGroups(request)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getLocationAssignedGroups(request: GroupRequestModel, state: any = {}): ng.IPromise<ResponseListModel<GroupModel>> {
        var getLocationAssignedGroups: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<GroupModel>>> = this.apiResource.groups['getLocationAssignedGroups']
        if (state.request == undefined) {
            state.request = getLocationAssignedGroups(request)
        }
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}
